import React from 'react';
import ReactMaskedInput from 'react-maskedinput';

import Input from './Input';

const DiMaskedInput = (props) => <Input component={ReactMaskedInput} {...props} />;

export default DiMaskedInput;
